import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/**
 * Minimal auth slice — holds the controlled login form state and the
 * loading flag the LoginForm reads via `useAppSelector(state => state.auth)`.
 *
 * Tokens / user / tenant context are NOT stored here — those live in the
 * encrypted Redis session. This slice is purely UI state.
 */
export interface AuthState {
  email: string;
  password: string;
  isLoading: boolean;
}

const initialState: AuthState = {
  email: "",
  password: "",
  isLoading: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setEmail(state, action: PayloadAction<string>) {
      state.email = action.payload;
    },
    setPassword(state, action: PayloadAction<string>) {
      state.password = action.payload;
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    clearAuthForm(state) {
      state.email = "";
      state.password = "";
      state.isLoading = false;
    },
  },
});

export const { setEmail, setPassword, setIsLoading, clearAuthForm } =
  authSlice.actions;
export default authSlice.reducer;
